import { Typography } from '@mui/material';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

export type SelectOption = {
  id: string | number;
  label: string | ReactNode;
};

/**
 * Adds an empty "Ninguna" (None) option to the beginning of a select options array.
 * This allows users to clear/remove a selection.
 *
 * @param options - Array of select options to prepend the empty option to
 * @returns New array with the empty option at the beginning
 */
export function withEmptyOption<T extends SelectOption>(
  options: readonly T[],
): Array<T | { id: ''; label: ReactNode }> {
  const emptyOption = {
    id: '' as const,
    label: (
      <Typography color="text.secondary" fontStyle="italic">
        <FormattedMessage id="socialExport.select.none" defaultMessage="Ninguna" />
      </Typography>
    ),
  };

  return [emptyOption, ...options];
}
